(function () {
  var cid = window.fioCustomerId || '';
  var KEY = 'fio:wish' + (cid ? ':' + cid : '');
  function read(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var list = read(KEY);
  if (cid) { var guest = read('fio:wish'); if (guest.length) { guest.forEach(function (h) { if (list.indexOf(h) < 0) list.push(h); }); write(list); try { localStorage.removeItem('fio:wish'); } catch (e) {} } }
  function toast(msg) {
    var t = document.createElement('div'); t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:100;padding:13px 20px;border-radius:18px;color:#F0ECDE;font-size:13px;background:rgba(59,44,39,.86);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px)';
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2200);
  }
  function paint() {
    document.querySelectorAll('[data-fio-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-fio-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remover dos favoritos' : 'Salvar nos favoritos');
      var l = b.querySelector('[data-fio-wish-label]'); if (l) l.textContent = on ? 'Nos favoritos' : 'Favoritar';
    });
    document.querySelectorAll('[data-fio-wish-count]').forEach(function (el) { el.textContent = list.length; });
  }
  function toggle(h) {
    var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removido dos favoritos'); } else { list.unshift(h); toast(cid ? 'Salvo nos favoritos' : 'Salvo nos favoritos · entre na conta para ver no seu perfil'); }
    write(list); paint(); renderLists();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fio-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 200);
    toggle(b.getAttribute('data-fio-wish'));
  }, true);
  function money(c) { var n = c / 100; return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function title(t) { return t.toLowerCase().split(' ').map(function (w, i) { return (i && ['de', 'da', 'do', 'e'].indexOf(w) > -1) ? w : w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); }
  var cache = {};
  function get(h) { if (!cache[h]) cache[h] = fetch(window.Shopify.routes.root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return cache[h]; }
  var heart = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.6-9.3-9.2C1.5 7.7 3.6 4.5 7 4.5c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.4 0 5.5 3.2 4.3 6.6-1.7 4.6-9.3 9.2-9.3 9.2z" fill="var(--fio-wish-fill, none)" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  function renderLists() {
    document.querySelectorAll('[data-fio-wishlist]').forEach(function (root) {
      var grid = root.querySelector('[data-fio-wl-grid]'), empty = root.querySelector('[data-fio-wl-empty]'), more = root.querySelector('[data-fio-wl-more]');
      var limit = +(root.getAttribute('data-limit') || 0), handles = limit ? list.slice(0, limit) : list.slice();
      empty.hidden = list.length > 0;
      if (more) more.hidden = !(limit && list.length > limit);
      if (!handles.length) { grid.innerHTML = ''; return; }
      Promise.all(handles.map(get)).then(function (items) {
        grid.innerHTML = items.map(function (p, i) {
          if (!p) return '';
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
          return '<div class="fio-wl__item">' +
            '<a class="fio-wl__media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<button type="button" class="fio-wish" data-fio-wish="' + handles[i] + '" aria-pressed="true" aria-label="Remover dos favoritos">' + heart + '</button>' +
            '<div class="fio-wl__meta"><a href="' + p.url + '">' + title(p.title) + '</a><span>' + money(p.price) + '</span></div>' +
            (p.available ? '' : '<div class="fio-label fio-wl__out">Esgotado</div>') + '</div>';
        }).join('');
      });
    });
  }
  function boot() { paint(); renderLists(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
